import { render, staticRenderFns } from "./ProjectSearchFacets.vue?vue&type=template&id=da72965a"
import script from "./ProjectSearchFacets.vue?vue&type=script&lang=js"
export * from "./ProjectSearchFacets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports